import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const Version = (props: any) => {
    const readmeContent = props?.content;

    const extractCurrentVersion = (markDown: string): string => {
        const currentVersion = markDown.indexOf('Current Version');
        const releaseInfoStart = markDown.indexOf('# Changelog');
        if (currentVersion === -1) return 'No version information found.';
        return markDown.substring(currentVersion, releaseInfoStart).replaceAll("Current Version", "");
    }

    const extractReleaseInfo = (markdown: string): string => {
        const releaseInfoStart = markdown.indexOf('# Changelog');
        const historyInfoStart = markdown.indexOf('# History');
        if (releaseInfoStart === -1) return 'No release information found.';

        return markdown.substring(releaseInfoStart + 1, historyInfoStart+1).replaceAll("Changelog", "");
    };

    return (
        <div className='version-info'>
            <table className='text-left'>
                <tr>
                    <th>Version</th>
                    <td>
                        <b>{extractCurrentVersion(readmeContent)}</b>
                    </td>
                </tr>
                <tr>
                    <th>Release Information</th>
                    <td>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {extractReleaseInfo(readmeContent)}
                        </ReactMarkdown>
                    </td>
                </tr>
            </table>
        </div>
    );
};

